import type { FaireProductEntity } from "../../entity_types/product";

export const p_34x2k2seq5: FaireProductEntity = {
  token: "p_34x2k2seq5",
  type: "product",
  name: "Copper Pyramid Yantra",
  brandToken: "b_qyxxvd286n",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/cc5d83a4be3acb83b62e96280564abf7c5ba337a0fbf90ca275c580db9e355a5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1aeef33566c5e9780daaf4abdc703b730345268003277f31a18f5b56f83a5428.jpeg",
    "https://cdn.faire.com/fastly/9d3915bb4aa50ddf748349c7152e2e5db5f0d0affc11ce36cc97b0c44ba01451.jpeg",
    "https://cdn.faire.com/fastly/83a2d12ba128367da54536b442824b8abb75132d79ae8fee3b067898178f79c5.jpeg",
    "https://cdn.faire.com/fastly/2e6c1cc8e60899a36a0723b61d2d0b91a478eb20ca50e073f68efd868f8ee9ab.jpeg",
  ],
  priceDollars: 20.09,
  description:
    "Copper Pyramid Yantra (Hollow)\n \n- Material: Premium Quality Copper\n- Made from 100% pure Copper\n- Size:  3 inches\n- Hollow\n- Bottom open\n- Weight: 30 to 40 Grams\n\nAuspicious Pyramid as combination of Shree Yantra, Shree Ganesha Yantra, Shree Kuber Yantra, and Kanakdhara Yantra\n\nPowerful Combination pf Yantra in copper pyramid making it one of the most powerful pyramids for Wealth and Vastu.\nEnergize, Balance, and Correct your space with highly effective Vastu Copper Pyramids\nHighly recommended Copper Vastu pyramid by healing experts & Vastu Consultant\nThe use of the Copper Vastu pyramid is a practical art to harmonize mind, body, and spirit with the environment. By just placing a copper pyramid at appropriate locations, you can achieve positive vibrations, good health, happiness, and prosperity.\n\nDisclaimer - The information provided is based on individual experience and should not be treated as medical advice. Inadvertent use of it will not be our responsibility.",
  tags: [],
  msrpDollars: 40.18,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:18.262Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
